import { render, staticRenderFns } from "./t-footer.vue?vue&type=template&id=074679d6&scoped=true&"
var script = {}
import style0 from "@/css/Main_style.scss?vue&type=style&index=0&id=074679d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074679d6",
  null
  
)

export default component.exports